import type { SkeletonProps } from '@cheqroom/components/Skeleton';
import { Skeleton as SharedSkeleton } from '@cheqroom/components/Skeleton';
import type { FC } from 'react';

// Can't `export { Skeleton } from '@cheqroom/components/Skeleton'` directly: that package resolves its own
// (React 19) @types/react, whose `ReactNode` also permits `bigint`/`Promise<ReactNode>` — not assignable
// to this package's React 18 `ReactNode`, so every JSX call site fails with "'Skeleton' cannot be used as
// a JSX component." Re-typing it here, once, avoids that at every use site — see Avatar.tsx for the same idiom.
export const Skeleton = SharedSkeleton as unknown as FC<SkeletonProps>;
export type { SkeletonProps as Props };
